type ReferenceDataLoadingState = {
  loading: boolean
  loaded: boolean
}

export function isBedbankMultiCartReviewGroupFetching(
  cartItemsStatus: string,
  referenceData: ReferenceDataLoadingState,
) {
  return cartItemsStatus === 'loading' || (referenceData.loading && !referenceData.loaded)
}
